angular.module("app").controller("EditPopupPageController", [
    '$scope',
    'pageStatuses',
    'popupsService',
    'logger',
    'errorHandler',
    'preloadedPopupData',
    'deepCompare',
    '$stateParams',
    'settingsService',
    'preloadedNames',
    function ($scope, pageStatuses, popupsService, logger, errorHandler, preloadedPopupData, deepCompare, $stateParams, settingsService, preloadedNames) {
        var init;

        $scope.actualPageNames = angular.copy(preloadedNames);

        $scope.pageStatuses = pageStatuses;
        $scope.settings = settingsService.getSettings();

        $scope.tooltip = {
            pageTitle: "",
            expiry_time: ""
        };

        (init = function (data, doNotUpdatePicker) {
            $scope.pageData = angular.copy(data);
            if (!doNotUpdatePicker) {
                $scope.vm = {
                    dateTimeFrom:  $scope.pageData.start_date && new Date($scope.pageData.start_date).toString() || ""
                };
            }
        })(preloadedPopupData);

        $scope.submitEditPopupForm = function () {
            delete $scope.pageData.forceTOChange;
            var changes = deepCompare.getChanges(angular.copy(preloadedPopupData), $scope.pageData);
            if (!!changes) {
                var requestObj = {
                    popup: angular.copy(changes)
                };
                requestObj.popup.id = $scope.pageData.id;
                (!!$scope.vm.fromDate || (!!preloadedPopupData.start_date && !$scope.vm.fromDate)) && (requestObj.popup.start_date = $scope.vm.fromDate || null);

                popupsService.update(requestObj).then(
                    function (response) {
                        if (response.status == "ok") {
                            updateScope();
                        } else {
                            errorHandler(response.message)
                        }
                    },
                    function (error) {
                        errorHandler(error.message);
                    }
                )
            }
        };

        $scope.handleChangeOfSetToAllLanguagesBox = function (isEnabled) {
            if (!isEnabled) {
                $scope.pageData.lang = $scope.pageData.lang || $scope.settings.skin.defaultLang || $scope.settings.skin.languages[0];
            }
        };

        $scope.handleChangeOfDateTimePicker = function (dateTime, dateToSave) {
            $scope.vm.dateTimeFrom = dateTime;
            $scope.vm.fromDate = dateToSave;
            $scope.pageData.start_date = $scope.vm.fromDate;
        };

        $scope.getChanges = function () {
            return deepCompare.isEqual($scope.pageData, angular.copy(preloadedPopupData));
        };

        function updateScope () {
            popupsService.getPopupById({id: $stateParams.popupId}).then(
                function (response) {
                    if (response.status == "ok") {
                        init(response.popup, true);
                        preloadedPopupData = angular.copy(response.popup);
                        logger.logSuccess("global.saved");
                        $scope.add_page_form && $scope.add_page_form.$setPristine && $scope.add_page_form.$setPristine();
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        }
    }
]);